import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  requirementsEntranceCollapseLabel: {
    id: 'course-authoring.schedule-section.requirements.entrance.collapse.label',
    defaultMessage: 'Grade requirements',
  },
  requirementsEntranceCollapseHelpText: {
    id: 'course-authoring.schedule-section.requirements.entrance.collapse.help-text',
    defaultMessage: 'The score student must meet in order to successfully complete the entrance exam.',
  },
});

export default messages;
